<div *ngIf="params.data && !params.data.editable">
    <span>{{params.data[params.colDef.field]}}</span>
</div>
<div *ngIf="params.data && params.data.editable">
    <select [(ngModel)]="displayDropdownValue" (ngModelChange)="onSelectChange($event)" style="width:100%;" *ngIf="currentField === 'legitimizationstatus'" >
        <option [value]="''"></option>
        <option *ngFor="let item of optionsList" [value]="item">{{item}}</option>
    </select>
    <select [(ngModel)]="displayDropdownValue" (ngModelChange)="onSelectChange($event)" style="width:100%;" *ngIf="currentField === 'uniontype'" >
        <option *ngFor="let item of optionsList" [value]="item.uniontype">{{item.uniontype}}</option>
    </select>
    <select [(ngModel)]="displayDropdownValue" (ngModelChange)="onSelectChange($event)" style="width:100%;" *ngIf="currentField === 'unionstatus'" >
        <option [value]="''"></option>
        <option *ngFor="let item of optionsList" [value]="item.unionstatus">{{item.unionstatus}}</option>
    </select>
    <select [(ngModel)]="displayDropdownValue" (ngModelChange)="onSelectChange($event)" style="width:100%;" *ngIf="currentField === 'evaluation'" >
        <option *ngFor="let item of optionsList" [value]="item.greekletter">{{item.greekletter}}</option>
    </select>
    <span class="requiredLabel" *ngIf="currentField === 'uniontype' && !displayDropdownValue && displayDropdownValue !== 'None-Selected'"></span>
    <span class="requiredLabel noneSelected" *ngIf="currentField === 'uniontype' && displayDropdownValue === 'None-Selected'"></span>
    <span class="requiredLabel" *ngIf="currentField === 'evaluation' && !displayDropdownValue"></span>
</div>